import HelpPanel from '@amzn/awsui-components-react/polaris/help-panel';
import React, { FC } from 'react';
import { i18nStrings } from 'utils/constants';

const EventDashboardHelp: FC = () => (
    <HelpPanel header={<h2>{i18nStrings.event.headers.eventInformation}</h2>}>
        <div>
            <h3>During the event</h3>
            <p>
                Follow the steps in the workshop guide using your own or a
                Workshop Studio provided AWS account.
            </p>
            <h3>Workshop Studio provided AWS accounts</h3>
            <p>
                You may be provided with a pre-provisioned AWS account for use
                during the event. The IAM role that we have provided has limited
                permissions, which will restrict you to the services and API
                calls required for the event. These accounts are temporary and
                access will be revoked after the session, at which time all
                resources will be deleted.
            </p>
            <h3>Ways to access your Workshop Studio provided account</h3>
            <p>There are a couple ways to access the provided AWS account.</p>
            <ul>
                <li>
                    Federated login link: A one-click login to the AWS console.
                    Use the <code>Open AWS console</code> link under the main
                    side navigation <code>AWS account access</code> section.
                </li>
                <li>
                    AWS CLI credentials: Shell environment variables needed to
                    make API calls using the AWS CLI. Use the{' '}
                    <code>Get AWS CLI credentials</code> link under the main
                    side navigation <code>AWS account access</code> section.
                </li>
                <li>
                    EC2 SSH key: SSH key pair required to access an Amazon EC2
                    instance provisioned for the event. Use the{' '}
                    <code>Get EC2 SSH key</code> link under the main side
                    navigation <code>AWS account access</code> section.
                </li>
            </ul>
        </div>
    </HelpPanel>
);

export default EventDashboardHelp;
